// Notch
const mobile = {
  notchHeight: 0,
};

// Color
const color = {
  primary: "#3c3c3c", // 메인 텍스트
  secondary: "#626a6f", // 진회색
  tertiary: "#979797", // 회색
  quaternary: "#c3c3c3", // 연회색
  main: "#00263e", // 남색색
  subMain: "#146eaa", // 연한 남색
  warning: "#f55555", // 빨강색
  subWarning: "#fa8c8c", // 서브빨강색
  markAs: "#126399", // 연남색
  markNotice: "#cde6f0", // 하늘색
  bgPrimary: "#f4f5f7", // 면 영역 회색
  linePrimary: "#e7e9ef", // 리스트 보더 회색
  lineSecondary: "#b9bebe", // 칩, 버튼 라인 회색
};

// Flex
// direction : row(default) | row-reverse | column | column-reverse
// justify : flex-start | flex-end | center | space-between(default) | space-around
// align : flex-start | flex-end | center(default) | baseline | stretch
// wrap : nowrap(default) | wrap | wrap-reverse
const flexBox = {
  flexMixin: (direction = "row", justify = "space-between", align = "center", wrap = "nowrap") => `
    display: flex;
    flex-wrap: ${wrap};
    flex-direction: ${direction};
    align-items: ${align};
    justify-content: ${justify};
    `,
  inlineFlex: (justify = "space-between", align = "center", wrap = "nowrap") => `
    display: inline-flex;
    flex-wrap: ${wrap};
    align-items: ${align};
    justify-content: ${justify};
  `,
};

// Font
// thin(100), ultralight(200), light(300), regular(400)
// medium(500), semibold(600), bold(700), extrabold(800), heavy(900)
const fontFamily = {
  appleGothicNeo: (string = "regular", num = 400) => `
    font-family: AppleSDGothicNeo-${string};
    font-weight: ${num}
  `,
};

// Text
const textOverflow = {
  singleLine: () => `
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  `,
  multiLine: (line = 2) => `
    display: -webkit-box;
    white-space: normal;
    overflow: hidden;
    -webkit-line-clamp: ${line};
    -webkit-box-orient: vertical;
  `,
};

// ImgBox
const imgBox = {
  coverBox: () => `
  overflow: hidden;
  position: relative;
  display: inline-block;
  width: 100%;
  padding-top: 100%;
  > img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    display: inline-block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  `,
};

export const theme = {
  mobile,
  color,
  flexBox,
  fontFamily,
  textOverflow,
  imgBox,
};

export type Theme = typeof theme;
